<template>
  <div class="appointment-filter">
    <div class="filter-box" :class="{ disabled }">
      <div class="filter-item" @click="onOpenFilter('city_id')">
        <span class="filter-label">{{ currentCity }}</span>
        <div class="arrow-icon"></div>
      </div>
      <div class="filter-item" @click="onOpenFilter('visa_country_id')">
        <span class="filter-label">{{
          selectedCountry ? selectedCountry.country : '国家'
        }}</span>
        <div class="arrow-icon"></div>
      </div>
      <div
        v-if="selectedCountry"
        class="filter-item"
        @click="onOpenFilter('show_visa_type_id')"
      >
        <span class="filter-label">{{ currentVisaType }}</span>
        <div class="arrow-icon"></div>
      </div>
    </div>
    <div class="list-toolbar">
      <div class="list-summary">
        <span v-if="loading">查询中...</span>
        <template v-else-if="!disabled">
          <span>共 {{ total }} 条</span>
        </template>
      </div>
      <van-checkbox
        class="available-label"
        shape="square"
        icon-size="0.12rem"
        checked-color="#fff"
        :value="filterInfo.is_have_date"
        :disabled="disabled"
        @input="onHaveDateChange"
      >
        <span class="available-text">仅看有可约日期</span>
      </van-checkbox>
    </div>
    <div v-if="dialogInfo.show" class="option-modal" @touchmove.self.prevent>
      <div class="modal-mask" @click="onCloseFilter" @touchmove.prevent></div>
      <div class="modal-content">
        <div class="modal-title" @touchmove.prevent>{{ dialogInfo.title }}</div>
        <div ref="optionList" class="option-list">
          <div
            class="option-item"
            :class="{ active: selectedValue === null }"
            @click="onChooseOption(null)"
          >
            <span>全部</span>
            <div v-if="selectedValue === null" class="checked-icon"></div>
          </div>
          <div
            v-for="item in dialogOptions"
            :key="item.value"
            class="option-item"
            :class="{ active: selectedValue === item.value }"
            @click="onChooseOption(item.value)"
          >
            <span>{{ item.label }}</span>
            <div v-if="selectedValue === item.value" class="checked-icon"></div>
          </div>
        </div>
        <div class="close-btn" @click="onCloseFilter" @touchmove.prevent>
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox as VanCheckbox } from 'vant';

export default {
  components: { VanCheckbox },
  props: {
    filterInfo: {
      type: Object,
      default: () => ({
        city_id: null,
        visa_country_id: null,
        show_visa_type_id: null,
        is_have_date: false,
      }),
    },
    configInfo: {
      type: Object,
      default: () => ({ city_id: null, city_set: {}, visa_country_set: [] }),
    },
    // 接口返回完整列表，父页面按数组长度传入条数。
    total: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      // 三种筛选共用一个弹窗，字段标明当前选项归属。
      dialogInfo: { show: false, field: '', title: '' },
    };
  },
  computed: {
    cityOptions() {
      return Object.keys(this.configInfo.city_set)
        .filter(
          (id) =>
            this.configInfo.city_set[id] &&
            this.configInfo.city_set[id] !== '未知',
        )
        .map((id) => ({ value: +id, label: this.configInfo.city_set[id] }));
    },
    selectedCountry() {
      return (
        this.configInfo.visa_country_set.find(
          (item) => item.visa_country_id === this.filterInfo.visa_country_id,
        ) || null
      );
    },
    visaTypeOptions() {
      return this.selectedCountry?.appointment_visa_type_config_set || [];
    },
    currentCity() {
      return (
        this.cityOptions.find((item) => item.value === this.filterInfo.city_id)
          ?.label || '城市'
      );
    },
    currentVisaType() {
      return (
        this.visaTypeOptions.find(
          (item) =>
            item.show_visa_type_id === this.filterInfo.show_visa_type_id,
        )?.show_visa_type || '签证类型'
      );
    },
    dialogOptions() {
      if (this.dialogInfo.field === 'city_id') return this.cityOptions;
      if (this.dialogInfo.field === 'visa_country_id') {
        return this.configInfo.visa_country_set.map((item) => ({
          value: item.visa_country_id,
          label: item.country,
        }));
      }
      if (this.dialogInfo.field === 'show_visa_type_id') {
        return this.visaTypeOptions.map((item) => ({
          value: item.show_visa_type_id,
          label: item.show_visa_type,
        }));
      }
      return [];
    },
    selectedValue() {
      return this.dialogInfo.field
        ? this.filterInfo[this.dialogInfo.field]
        : null;
    },
  },
  methods: {
    onOpenFilter(field) {
      if (this.disabled) return;
      const titles = {
        city_id: '申请城市',
        visa_country_id: '目的地国家',
        show_visa_type_id: '签证类型',
      };
      if (
        !titles[field] ||
        (field === 'show_visa_type_id' && !this.selectedCountry)
      )
        return;
      this.dialogInfo = { show: true, field, title: titles[field] };
      this.$nextTick(() => {
        const list = this.$refs.optionList;
        if (!list) return;
        const active = list.querySelector('.active');
        if (active) list.scrollTop = active.offsetTop - list.offsetTop;
      });
    },
    onCloseFilter() {
      this.dialogInfo = { show: false, field: '', title: '' };
    },
    onChooseOption(value) {
      if (this.disabled) return;
      this.changeFilter(
        this.dialogInfo.field,
        value === null ? null : Number(value),
      );
      this.onCloseFilter();
    },
    onHaveDateChange(value) {
      this.changeFilter('is_have_date', value);
    },
    changeFilter(field, value) {
      if (this.disabled || !field) return;
      const filterInfo = { ...this.filterInfo, [field]: value };
      if (field === 'visa_country_id') filterInfo.show_visa_type_id = null;
      this.$emit('change', { field, filterInfo });
    },
  },
};
</script>

<style lang="less" scoped>
.appointment-filter {
  padding: 0.25rem 0.15rem 0.22rem;
  color: #fff;
  text-align: center;

  .filter-box {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: 0.38rem;
    padding: 0 0.04rem;
    border-radius: 0.2rem;
    background: rgba(0, 0, 0, 0.3);
    &.disabled {
      opacity: 0.6;
    }
  }
  .filter-item {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    padding: 0 0.09rem;
    font-size: 0.13rem;
    & + .filter-item {
      border-left: 0.005rem solid rgba(255, 255, 255, 0.4);
    }
  }
  .filter-label {
    overflow: hidden;
    max-width: 1.1rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .arrow-icon {
    flex-shrink: 0;
    width: 0.1rem;
    height: 0.1rem;
    margin-left: 0.04rem;
    background: url('https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/ssqwxa/earliest-date/icon-down.png')
      no-repeat center / 0.065rem 0.045rem;
  }

  .list-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 0.18rem;
    margin-top: 0.12rem;
    font-size: 0.1rem;
    text-align: left;
  }
  .list-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-width: 0;
  }
  .query-time {
    margin-left: 0.08rem;
  }
  .available-label {
    display: flex;
    align-items: center;
    margin-left: 0.06rem;
    white-space: nowrap;
    ::v-deep .van-checkbox__icon:not(.van-checkbox__icon--disabled) .van-icon {
      border-color: #fff;
      background-color: #fff;
    }
    ::v-deep
      .van-checkbox__icon--checked:not(.van-checkbox__icon--disabled)
      .van-icon {
      color: #fe595f;
    }
    ::v-deep .van-checkbox__label {
      margin-left: 0.04rem;
    }
  }
  .available-text {
    color: #fff;
    font-size: 0.1rem;
    line-height: 1;
  }

  .option-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2f333d;
  }
  .modal-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  .modal-content {
    position: relative;
    overflow: hidden;
    width: 3rem;
    border-radius: 0.06rem;
    background: #fff;
    font-size: 0.14rem;
  }
  .modal-title {
    padding: 0.14rem 0.12rem;
    border-bottom: 0.005rem solid #e9eef2;
    color: #91999f;
  }
  .option-list {
    height: 2.6rem;
    max-height: 60vh;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }
  .option-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-height: 0.44rem;
    padding: 0.1rem 0.32rem;
    border-bottom: 0.005rem solid #e9eef2;
    &.active {
      color: #fe595f;
    }
  }
  .checked-icon {
    position: absolute;
    right: 0.12rem;
    width: 0.14rem;
    height: 0.14rem;
    background: url('https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdvwxa/earliest-date/icon-select.png')
      no-repeat center / contain;
  }
  .close-btn {
    padding: 0.12rem;
    border-top: 0.005rem solid #e9eef2;
    color: #91999f;
  }
}
</style>
